/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

import { SNACKBAR_MESSAGE, HIDE_MESSAGE } from "./types"
const snackBarInitialState = {
	snackBarMessage: {
		showSnackbar: false,
		autoHideDuration: 5000,
		message: '',
		severity: ''
	}
}

export const snackBarReducer = (state = snackBarInitialState, action: any) => {
	switch (action.type) {
		case SNACKBAR_MESSAGE:
			return {
				...state,
				snackBarMessage: action.snackBarSuccess
			}
		case HIDE_MESSAGE:
			return {
				snackBarMessage: {
					...state.snackBarMessage,
					showSnackbar: action.showSnackbar
				}
			}
		default:
			return state;
	}
}